import { Injectable, inject } from '@angular/core';
import { handleError } from '@core/helpers';
import { GoogleMapsApiService } from '@core/services/google-maps-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  loadGoogleMapsApi,
  loadGoogleMapsApiFailure,
  loadGoogleMapsApiSuccess,
} from './actions';

@Injectable()
export class GoogleMapsApiEffects {
  private actions$ = inject(Actions);
  private googleMapsApiService = inject(GoogleMapsApiService);

  getGoogleMapsApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadGoogleMapsApi),
      switchMap(() =>
        this.googleMapsApiService.loadGoogleMapsApi().pipe(
          map(() => loadGoogleMapsApiSuccess()),
          catchError((error) => handleError(error, loadGoogleMapsApiFailure)),
        ),
      ),
    ),
  );
}
